import React, { useMemo, useState, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { StepHelp } from '../StepHelp/StepHelp';
import { helpConfig } from '../../config/helpConfig';
import { Box } from '@material-ui/core';

export const GlobalHelp = () => {
    const location = useLocation();
    const [activeModalTitle, setActiveModalTitle] = useState(null);

    useEffect(() => {
        const checkModals = () => {
            // Find visible MUI Dialogs that are NOT the StepHelp dialog itself
            const dialogs = document.querySelectorAll('.MuiDialog-root:not(#step-help-dialog)');
            
            // Check if any are actually visible
            let foundModal = null;
            for (let i = dialogs.length - 1; i >= 0; i--) {
                const dialog = dialogs[i];
                // Ignore hidden dialogs
                if (dialog.getAttribute('aria-hidden') !== 'true' && window.getComputedStyle(dialog).visibility !== 'hidden') {
                    // Try to find the title element
                    const titleEl = dialog.querySelector('.MuiDialogTitle-root');
                    if (titleEl) {
                        foundModal = titleEl.textContent || titleEl.innerText;
                        break;
                    }
                }
            }
            setActiveModalTitle(foundModal ? foundModal.trim() : null);
        };

        // Initial check
        checkModals();

        // Observe the DOM for any dialogs being added/removed or visibility changes
        const observer = new MutationObserver(() => {
            checkModals();
        });

        observer.observe(document.body, { 
            childList: true, 
            subtree: true, 
            attributes: true, 
            attributeFilter: ['aria-hidden', 'style', 'class'] 
        });

        return () => observer.disconnect();
    }, []);

    // Find the matching help config prioritizing Modals, then Pages
    const currentHelp = useMemo(() => {
        // 1. Prioritize Modal Help Context
        if (activeModalTitle && helpConfig.modals) {
            // Attempt an exact match or partial match on the modal title
            const modalMatch = helpConfig.modals[activeModalTitle] || 
                               Object.values(helpConfig.modals).find(m => activeModalTitle.includes(m.matchTitle));
            
            if (modalMatch) {
                return modalMatch;
            }
        }

        // 2. Fallback to Page-Level Help Context
        if (helpConfig.pages) {
            const match = helpConfig.pages.find(config => 
                matchPath(location.pathname, { path: config.path, exact: config.exact })
            );
            return match ? match.help : null;
        }

        return null;
    }, [location.pathname, activeModalTitle]);

    if (!currentHelp) return null;

    return (
        <Box 
            style={{ 
                position: 'fixed', 
                right: 24,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 9999 
            }}
        >
            <StepHelp 
                title={currentHelp.title} 
                description={currentHelp.description} 
                content={currentHelp.content} 
            />
        </Box>
    );
};
